import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
    UPDATE_GROUP_STATUS: {
        url: "gebruiker/group/update",
        method: "post",
    },

    GET_FUNCTIES_DATA: (adminId) => ({
        url: `gebruiker/functies?iAdminId=${adminId}`,
        method: "post",
    }),
};


// Update group status
export const useUpdateGroupStatus = () =>
    useApiFetcherSWR(API_ENDPOINT.UPDATE_GROUP_STATUS);


// Get functies data
export const useFunctiesData = (adminId) =>
    useApiFetcherSWR(
        adminId
            ? API_ENDPOINT.GET_FUNCTIES_DATA(adminId)
            : null
    );